/**
 * Created by Arif Topcu in 2019
 */

import ComplicationSelector from '@ls/grouping-complication-selector';
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setDefinition as setBetaDefinition} from 'state/betas/actions';
import BetaDefinition from 'state/betas/BetaDefinition';
import {selectDefinitions} from 'state/betas/selectors';
import SelectionState from 'state/selections/SelectionState';
import BetaSelectorComplication from './BetaSelectorComplication';


const BetaSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(selectDefinitions(SelectionState.UNCOMMITTED));
  const setDefinition = useCallback(
    (idx, definition) => dispatch(setBetaDefinition(idx, definition)),
    [dispatch],
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={BetaDefinition.getDefault}
      ComplicationComponent={BetaSelectorComplication}
      btnTitle={'Betas'}
      addMoreText={'Beta Column'}
    />
  );
};

export default BetaSelector;
